module.exports = __webpack_public_path__ + "static/img/brees-2014-slide-6.c28954b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2014-slide-6.jpg
// module id = K1wJ
// module chunks = 1